import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f7a2c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact-form" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" We’re Excited To "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Meet You!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Get ready for the biggest journey of your career. Apply today! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = ["action"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"side\" data-v-21f7a2c3><div class=\"input-holder\" data-v-21f7a2c3><label for=\"fname\" data-v-21f7a2c3>Full Name <span class=\"required\" data-v-21f7a2c3>*</span></label><input type=\"text\" name=\"fname\" placeholder=\"Full Name\" required data-v-21f7a2c3></div><div class=\"input-holder\" data-v-21f7a2c3><label for=\"email\" data-v-21f7a2c3>Email <span class=\"required\" data-v-21f7a2c3>*</span></label><input type=\"email\" name=\"email\" placeholder=\"Email\" required data-v-21f7a2c3></div><div class=\"input-holder\" data-v-21f7a2c3><label for=\"phone\" data-v-21f7a2c3>Phone <span class=\"required\" data-v-21f7a2c3>*</span></label><input type=\"tel\" name=\"phone\" placeholder=\"Phone\" required data-v-21f7a2c3></div><div class=\"input-holder\" data-v-21f7a2c3><label for=\"attachment\" data-v-21f7a2c3>Resume</label><input type=\"file\" name=\"attachment\" placeholder=\"Click to Upload\" data-v-21f7a2c3></div></div>", 1)
const _hoisted_7 = { class: "side" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-holder" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Comments"),
  /*#__PURE__*/_createElementVNode("textarea", {
    name: "message",
    placeholder: "Additional Comments (optional)"
  })
], -1))
const _hoisted_9 = {
  class: "btn",
  type: "submit"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Let it fly ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "_subject",
  value: "New CV from ADV.BET"
}, null, -1))
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", {
        class: "contact-us",
        action: `https://formsubmit.co/${_ctx.email}`,
        method: "POST",
        enctype: "multipart/form-data"
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("button", _hoisted_9, [
            _createVNode(_component_FAIcon, {
              icon: "paper-plane",
              class: "ico"
            }),
            _hoisted_10
          ])
        ]),
        _hoisted_11,
        _createElementVNode("input", {
          type: "hidden",
          name: "position",
          value: _ctx.position
        }, null, 8, _hoisted_12)
      ], 8, _hoisted_5)
    ])
  ]))
}